export default __webpack_public_path__ + "static/media/oliver-peoples-13.45f039f0.png";